<button 
    type="button" 
    class="c-stop-header__link c-link--underlined"
    [class.is-disabled]="!currentPortCall()"
    [disabled]="!currentPortCall()"
    (click)="onChangePortCallAsActive()">
    {{ 'voyage.portCallCurrent' | translate}}
</button>